import { toDecimals } from './format';

export const calcPercDiscount = (valueBase, valueWithDiscount, precision) =>
  toDecimals(((valueBase - valueWithDiscount) / valueBase) * 100, precision ?? 4);
